<h2>Figure Regolamentate/Abilitanti</h2>
<p>Questa sezione è dedicata alle professioni regolamentate da legge o altro atto dello Stato, che stabilisce
l'obbligatorietà della formazione per l'esercizio di una specifica attività professionale.</p>

<p>La Direzione Generale IFL, in raccordo con le direzioni competenti per materia, ha stabilito standard formativi e
completato quelli professionali dei percorsi formativi relativi a figure professionali, regolamentate da leggi o atti
nazionali e/o Accordo in Conferenza Stato-Regioni. Ciascun percorso formativo, che risponde agli standard minimi così
definiti, è valido ai fini dell'abilitazione professionale su tutto il territorio nazionale e permette di accedere
all'esercizio della specifica attività professionale, anche attraverso l'iscrizione ad appositi elenchi/Albi/registri</p>

<p>Infatti in taluni casi tale formazione obbligatoria costituisce uno dei requisiti ai fini dell'iscrizione ad Albo,
Registro o Elenco, come stabilito dalla specifica normativa nazionale</p>

<p>Le competenze afferenti le figure professionali regolamentate non possono essere certificate attraverso il processo di
riconoscimento delle competenze acquisite in ambito informale e non formale.</p>

<p>L'attestato finale rilasciato a conclusione positiva del percorso formativo deve essere necessariamente afferente tutte
le competenze della figura professionale di riferimento.</p>

<p>L'elenco delle figure professionali previsto in questa sezione non è esaustivo ma fa riferimento prioritariamente alle
professioni ricorrenti nell'offerta formativa regionale.</p>

<div class="example-container mat-elevation-z8">
  <div class="example-table-container">

    <table mat-table [dataSource]="dataSource" class="example-table" matSort matSortActive="descrizione" matSortDisableClear matSortDirection="asc">
       <ng-container matColumnDef="descrizione">
           <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
               Descrizione
             </th>
             <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
       </ng-container>
       <ng-container matColumnDef="azioni">
           <th mat-header-cell *matHeaderCellDef>
               Azioni
             </th>
             <td mat-cell *matCellDef="let element">
               <mat-icon class="green" (click)="downloadFigura(element.idDocumento)"
               matTooltip="Download Documento">download</mat-icon>
               <mat-icon class="green" (click)="elencoCorsi(element)"
               matTooltip="Visualizza Elenco Corsi">search</mat-icon>
              </td>
       </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
    </table>
  </div>

  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"
  [pageIndex]="pageIndex" (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>
</div>
